import { createSlice } from '@reduxjs/toolkit';

const websocketSlice = createSlice({
  name: 'websocket',
  initialState: [],
  reducers: {
  },
});

export default websocketSlice.reducer;
